import { all } from 'redux-saga/effects'

import { updateSaga } from './update/saga'
import { resumeSaga } from './resume/sagas'

export function* studentSaga() {
  yield all([updateSaga(), resumeSaga()])
}
